export const formatPhoneNumber = (phoneNumber) => {
    const formattedPhoneNumber = phoneNumber.replace(/\D/g,'').substring(2);

    return formattedPhoneNumber;
}